export const FAST_WEB_HELP_URL = 'https://help.formulatrix.com/fast';

export const FAST_CSV_IMPORT_WEB_HELP_URL =
  'https://help.formulatrix.com/fast/1.46/#Designing_Protocols/Tutorials/Importing_Experiment_Data_%28CSV_Import%29.htm';

export const FAST_LIQUID_HANDLER_BASE_URL = `${window.location.protocol}//${window.location.host}`;
export const FAST_INSTRUMENT_BASE_URL = `${window.location.protocol}//${window.location.host}`;
export const FORMULATRIX_LABWARE_BASE_URL = `${window.location.protocol}//${window.location.host}`;
